import {AppRouteEnum, MenuAction, MenuActionGroup, MenuActionType} from '@shared/model';

export class MenuHelperUtils {
  public static generateMenu(_: string = ''): MenuActionGroup[] {
    return MenuHelperUtils.generateDefaultMenu();
  }

  public static generateDefaultMenu(): MenuActionGroup[] {
    return [
      {
        title: 'menu.configuration',
        color: '#c41a54',
        actions: [
          {icon: MenuHelperUtils.CONTROL_ICON, title: 'menu.control', link: AppRouteEnum.CONTROL_HOME},
          {
            icon: MenuHelperUtils.GENERATOR_TEMPLATE_ICON,
            title: 'menu.generator-template',
            link: AppRouteEnum.GENERATOR_TEMPLATE_HOME
          },
          {
            icon: MenuHelperUtils.EMAIL_ICON,
            title: 'menu.email-parameter',
            link: AppRouteEnum.APPLICATION_EMAIL
          },
        ]
      },
      {
        title: 'menu.workforce',
        color: '#2ecc71',
        actions: [
          {icon: MenuHelperUtils.RANK_ICON, title: 'menu.rank', link: AppRouteEnum.RANK},
          {icon: MenuHelperUtils.EMPLOYEE_ICON, title: 'menu.employee', link: AppRouteEnum.EMPLOYEE_HOME},
          {
            icon: MenuHelperUtils.EMPLOYEE_SETTING_ICON,
            title: 'menu.employee-setting',
            link: AppRouteEnum.EMPLOYEE_SETTING_HOME
          },
          {icon: MenuHelperUtils.TEAM_ICON, title: 'menu.team', link: AppRouteEnum.TEAM_HOME},
          {icon: MenuHelperUtils.SECTION_ICON, title: 'menu.section', link: AppRouteEnum.SECTION_HOME},
          {icon: MenuHelperUtils.ROLE_ICON, title: 'menu.role', link: AppRouteEnum.ROLE_HOME},
        ]
      },
      {
        title: 'menu.prestations',
        color: '#e67e22',
        actions: [
          {
            icon: MenuHelperUtils.PRESTATION_TYPE_ICON,
            title: 'menu.prestation-type',
            link: AppRouteEnum.PRESTATION_TYPE_HOME
          },
          {icon: MenuHelperUtils.TASK_ICON, title: 'menu.task', link: AppRouteEnum.TASK_HOME},
          {
            icon: MenuHelperUtils.EXCHANGE_REQUEST_ICON,
            title: 'menu.exchange-request',
            link: AppRouteEnum.EXCHANGE_REQUEST_HOME
          },
        ]
      },
      {
        title: 'menu.calendar',
        color: '#9b59b6',
        actions: [
          {icon: MenuHelperUtils.EVENT_ICON, title: 'menu.event', link: AppRouteEnum.EVENT_HOME},
          {icon: MenuHelperUtils.REMEMBER_ICON, title: 'menu.remember', link: AppRouteEnum.REMEMBER_HOME},
          {icon: MenuHelperUtils.PLANNING_ICON, title: 'menu.leave', link: AppRouteEnum.LEAVE_HOME},
          {icon: MenuHelperUtils.CLOCK_ICON, title: 'menu.quotas', link: AppRouteEnum.QUOTAS_HOME},
        ]
      },
      {
        title: 'menu.absence-leave',
        color: '#0f265b',
        actions: [
          {icon: MenuHelperUtils.ABSENCES_TYPES_ICON, title: 'menu.absence-type', link: AppRouteEnum.ABSENCE_TYPE},
          {icon: MenuHelperUtils.ABSENCES_ICON, title: 'menu.absence', link: AppRouteEnum.ABSENCE},
        ]
      },

    ];
  }

  public static generateDataListStandardAction(): MenuAction[] {
    return [
      {icon: MenuHelperUtils.EDIT_ICON, title: 'menu.planning', type: MenuActionType.UPDATE},
      {icon: MenuHelperUtils.DELETE_ICON, title: 'menu.generator-template', type: MenuActionType.DELETE,},
    ]
  }

  // list of icon
  public static ECO_SYSTEM_ICON: string = 'fa-regular fa-database';
  public static ADD_ICON: string = 'fa-regular fa-plus';
  public static BACK_ICON: string = 'fa-regular fa-rotate-left';
  public static EDIT_ICON: string = 'fa-regular fa-pencil-alt';
  public static DELETE_ICON: string = 'fa-regular fa-trash';
  public static RESTORE_ICON: string = 'fa-regular fa-trash-can-arrow-up';
  public static DELETED_LIST_ICON: string = 'fa-solid fa-trash-can';
  public static PLANNING_ICON: string = 'fa-regular fa-calendar';
  public static GENERATOR_TEMPLATE_ICON: string = 'fa-regular fa-chart-tree-map';
  public static CONTROL_ICON: string = 'fa-regular fa-shield-check';
  public static PRESTATION_TYPE_ICON: string = 'fa-regular fa-diagram-cells';
  public static EXCHANGE_REQUEST_ICON: string = 'fa-regular fa-arrow-right-arrow-left';
  public static VISUAL_PRESTATION_TYPE_ICON: string = 'fa-solid fa-palette';
  public static EVENT_ICON: string = 'fa-regular fa-clock';
  public static PRESTATION_ICON: string = 'fa-regular fa-presentation-screen';
  public static RANK_ICON: string = 'fa-regular fa-user-tag';
  public static EMPLOYEE_ICON: string = 'fa-regular fa-user';
  public static EMPLOYEE_SETTING_ICON: string = 'fa-regular fa-sliders';
  public static TEAM_ICON: string = 'fa-regular fa-users';
  public static SECTION_ICON: string = 'fa-regular fa-user-group';
  public static ROLE_ICON: string = 'fa-regular fa-key-skeleton-left-right';
  public static REMEMBER_ICON: string = 'fa-regular fa-alarm-clock';
  public static PARAMETER_ICON: string = 'fa-regular fa-gears';
  public static HISTORY_ICON: string = 'fa-regular fa-rectangle-vertical-history';
  public static ADDRESS_ICON: string = 'fa-regular fa-map';
  public static DUPLICATE_ICON: string = 'fa-regular fa-clone';
  public static HELP_ICON: string = 'fa-regular fa-question';
  public static PERMISSION_ICON: string = 'fa-regular fa-lock-a';
  public static INFO_ICON: string = 'fa-regular fa-circle-info';
  public static VISUAL_ICON: string = 'fa-regular fa-eye';
  public static TIME_ICON: string = 'fa-regular fa-clock';
  public static CONFIGURATION_ICON: string = 'fa-regular fa-gear';
  public static GALOP_ICON: string = 'fa-regular fa-horse';
  public static TASK_ICON: string = 'fa-regular fa-list-check';
  public static CONNECTION_ICON: string = 'fa-regular fa-user-lock';
  public static IDENTITY_CONFIG_ICON: string = 'fa-regular fa-circle-info';
  public static FLAG_CONFIG_ICON: string = 'fa-regular fa-gear';
  public static SPEC_CONFIG_ICON: string = 'fa-regular fa-gear';
  public static PRESTATYPE_CONFIG_ICON: string = 'fa-regular fa-badge-check';
  public static IMPORT_ICON: string = 'fa-light fa-file-import';
  public static UPDATE_ICON: string = 'fa-solid fa-square-pen';
  public static PLANNING_RESTRICTION_ICON = 'fa-regular fa-shield';
  public static SPECIALIZATIONS_ICON = 'fa-regular fa-folder';
  public static ABSENCES_ICON = 'fa-solid fa-user-slash';
  public static ABSENCES_TYPES_ICON = 'fa-regular fa-clipboard';
  public static LIST_ICON = 'fa-solid fa-list';
  public static EMAIL_ICON = 'fa-regular fa-envelope';
  public static CLOCK_ICON = 'fa-regular fa-clock';
}
